import React, { Component } from 'react';


interface IProps {

}

interface IState {
    str:string;
    anchorEl: null | HTMLElement;
    open: any,
    value:string,
    openModal:boolean,
    openActionModal:boolean
}

export class PolicyController extends Component<IProps, IState> {

    arrowRef:any;
    
    constructor(props: any) {
         super(props);
        this.arrowRef = React.createRef();
    }
     
    state: IState = {
        str:"",
        anchorEl: null,
        open: false,
        value:"",
        openModal:false,
        openActionModal:false
       
    };
    id: any = this.state.open ? 'simple-popper' : undefined;

    search = async (e:any) => {
        this.setState({ str: e })
    };
    handleChange = (e:any) => {
        this.setState({ value: e })
    };
    
    handleClick = (event: any) => {
        this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
        this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

    };
}
export default PolicyController;